export const EVENT_DEFAULT_TIME = "12:00 PM";

export const openInviteKey = "openInvite";
export const inviteOnlyKey = "inviteOnly";

// Timezone options
export type TimezoneOption = {
  label: string;
  value: string;
};

// Timezones with their display names (offset will be calculated dynamically)
export const TIMEZONE_OPTIONS: TimezoneOption[] = [
  { label: "Samoa", value: "Pacific/Pago_Pago" },
  { label: "Hawaii", value: "Pacific/Honolulu" },
  { label: "Gambier", value: "Pacific/Gambier" },
  { label: "Alaska", value: "America/Anchorage" },
  { label: "Pacific Time (US & Canada)", value: "America/Los_Angeles" },
  { label: "Arizona", value: "America/Phoenix" },
  { label: "Mountain Time (US & Canada)", value: "America/Denver" },
  { label: "Central Time (US & Canada)", value: "America/Chicago" },
  { label: "Eastern Time (US & Canada)", value: "America/New_York" },
  { label: "Atlantic Time (Canada)", value: "America/Halifax" },
  { label: "Brasilia", value: "America/Sao_Paulo" },
  { label: "Cape Verde", value: "Atlantic/Cape_Verde" },
  { label: "UTC", value: "UTC" },
  { label: "London", value: "Europe/London" },
  { label: "Paris", value: "Europe/Paris" },
  { label: "Berlin", value: "Europe/Berlin" },
  { label: "Athens", value: "Europe/Athens" },
  { label: "Moscow", value: "Europe/Moscow" },
  { label: "Dubai", value: "Asia/Dubai" },
  { label: "Karachi", value: "Asia/Karachi" },
  { label: "Mumbai", value: "Asia/Kolkata" },
  { label: "Dhaka", value: "Asia/Dhaka" },
  { label: "Bangkok", value: "Asia/Bangkok" },
  { label: "Beijing", value: "Asia/Shanghai" },
  { label: "Tokyo", value: "Asia/Tokyo" },
  { label: "Sydney", value: "Australia/Sydney" },
  { label: "Auckland", value: "Pacific/Auckland" },
];
